import React from "react";

// motion
import { motion } from "framer-motion";

// Variant
import { fadeIn } from "../variants";

import "../index.css";

import { ProjectList } from "./ProjectsList";

const Work = () => {
  return (
    <div id="work" className="lg:mt-[200px] mt-[50px] section h-auto">
      <div className="container mx-auto w-[90%]">
        <div className="flex flex-col lg:flex-row lg:flex-3 gap-x-10">
          <div className="grid grid-rows-1 lg:grid-cols-2  gap-12 mb-10 lg:mb-0 ">
            {/* text */}
            <div className="">
              <h2 className="h2 w-full text-center leading-tight text-accent font-extrabold ">
                My latest <span>Projects</span>
              </h2>
              <p className=" w-full text-center  max-w-full md:max-w-full lg:mb-[150px] mb-26 sm:mb-[90px] lg:text-2xl">
                Welcome to my portfolio, a curated collection of my creative
                endeavors and technical explorations. Each project represents a
                journey of innovation, problem-solving, and passion. From
                concept to execution, these projects embody my dedication to
                pushing boundaries and delivering meaningful experiences.
              </p>
            </div>

            {/* image */}

            {/* images preview */}
            {ProjectList.map((items) => (
              <div key={items.id}>
                <div className="group relative h-[300px] lg:h-[350px] overflow-hidden border-2 border-white/20 rounded-xl">
                  {/* live batch */}
                  {items.live && (
                    <div className="absolute py-1 flex px-5 bg-red-600 right-0  gap-3">
                      <span>Live</span>{" "}
                      <span className="flex expand-contract items-center justify-center align-middle w-2 h-2 rounded-full p-1 mt-3  bg-white"></span>
                    </div>
                  )}
                  {/* overlay */}
                  <div className="group-hover:bg-black/70 w-full h-full absolute z-40 translation-all duration-300"></div>{" "}
                  <img
                    src={items.img}
                    alt="website-image"
                    className="h-full group-hover:scale-[125%] translation-all duration-500 w-full "
                  />
                  {/* pretitle */}
                  <div className="absolute h-[10%]  px-10 mx-auto -bottom-full  group-hover:bottom-[230px] lg:group-hover:bottom-[250px] transition-all duration-500 z-[50] w-full">
                    <span className="text-gradient font-extrabold text-2xl ">
                      {items.title}
                    </span>
                  </div>
                  {/* Project title */}
                  <div className="absolute -bottom-full left-9 group-hover:bottom-11 transition-all duration-700 z-[50]">
                    <span className="text-2xl lg:text-3xl text-white">
                      <article className="w-[80%] mb-2 text-sm md:text-md lg:text-lg">
                        {items.expalain}
                      </article>
                      <div className="flex justify-between w-[80%]">
                        {items.link.length > 0 && (
                          <a href={items.link}>
                            <span className="px-5 btn bt text-[15px] p-2">
                              Visit site
                            </span>
                          </a>
                        )}

                        {items.git.length > 0 && (
                          <a href={items.git}>
                            <span className="px-7 btn bt text-[15px] p-2">
                              Git
                            </span>
                          </a>
                        )}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
